import {checkEmailIsValid} from '../../_common/utils/checkEmailIsValid';
import {isContactPhoneExists, isEmailExists} from '../actions/ContactsActions';

export const validate = async (values, initialValues) => {
  let errors = {};

  if (!values.firstName) {
    errors.firstName = 'Required';
  }
  if (!values.lastName) {
    errors.lastName = 'Required';
  }
  if (!values.phone) {
    errors.phone = 'Required';
  }
  if (values.phone) {
    if (await isContactPhoneExists(values.phone) && values.phone !== initialValues.phone) {
      errors.isPhoneAlreadyExists = 'Contact phone already exists';
    }
  }
  if (values.email && !checkEmailIsValid(values.email)) {
    errors.email = 'Invalid email address';
  }
  if (values.email) {
    if (await isEmailExists(values.email) && values.email !== initialValues.email) {
      errors.isEmailAlreadyExists = 'Contact email already exists';
    }
  }

  return errors;
};